export default "__VITE_ASSET__CUZR74bA__"